export default "__VITE_ASSET__Bx38Vsit__"